import styled, { breakpoints } from '../../../styles/theme';
import HeaderStyled from '../HeaderStyled';
import { rem } from 'polished';

export const HeaderStyledOV = styled(HeaderStyled)`
    background: ${({ theme }) => theme.colors.pureWhite};
    color: ${({ theme }) => theme.colors.black2};
    padding: ${rem('10px')};
    border: none;

    @media (min-width: ${breakpoints.xs}px) {
        padding: 0 ${rem('28px')};
    }

    .header__nav-wrapper {
        text-align: center;
    }

    .header-container {
        padding-left: 0;
        padding-right: 0;
        padding-top: 30px;
        height: ${rem('100px')};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        font-family: ${({ theme }) => theme.fonts.fontBase};

        .skip-content a {
            font-size: ${rem('12px')};
            color: ${({ theme }) => theme.colors.black};
        }

        @media (max-width: ${breakpoints.xs}px) {
            margin-left: 10px;
            padding-top: 5px;
            height: auto;
        }

        > * {
            flex-grow: 1;
            flex-basis: 0;
        }

        @media (min-width: ${breakpoints.sm}px) {
            .logo > span {
                margin-top: -15px;
            }
        }

        .logo > span {
            display: flex;
            justify-content: center;
            align-items: center;
            color: black;

            svg {
                width: ${rem('34px')};
                height: ${rem('34px')};

                @media (min-width: ${breakpoints.xs}px) {
                    width: ${rem('68px')};
                    height: ${rem('68px')};
                }
            }
        }
    }

    .center-logo-section .logo {
        display: none;
    }

    .header-logo-icon {
        width: ${rem('34px')};
        height: ${rem('34px')};

        @media (min-width: ${breakpoints.xs}px) {
            width: ${rem('68px')};
            height: ${rem('68px')};
        }
    }

    .title-section {
        border: none;
        margin-left: 0;
        padding: 0;

        @media (min-width: ${breakpoints.xs}px) {
            padding: 0 ${rem(30)};
        }
        @media (max-width: ${breakpoints.xs}px) {
            margin-left: ${rem(12)};
        }

        .title-primary {
            @media (max-width: ${breakpoints.xs}px) {
                font-size: 12px;
                line-height: 100%;
            }

            font-size: 30px;
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            line-height: 36px;
            letter-spacing: 0;
            color: ${({ theme }) => theme.colors.black2};
            text-decoration: none;
            cursor: pointer;
            text-transform: none;
            @media (min-width: ${breakpoints.xs}px) {
                font-size: 40px;
                line-height: 45px;
            }
        }

        .title-secondary {
            @media (max-width: ${breakpoints.xs}px) {
                font-size: 10px;
                line-height: 100%;
                margin-bottom: 0;
            }

            font-size: 18px;
            line-height: 20px;
            margin: 0.3rem 0 2rem 0;
            font-weight: 400;
        }
    }

    .navigation {
        justify-content: flex-end;

        a {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            color: ${({ theme }) => theme.colors.black};
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};

            p {
                text-align: left;
                font-size: ${rem('10px')};
                font-weight: normal;
                line-height: ${({ theme }) => theme.lineHeights.textSupMedium};
                @media (min-width: ${breakpoints.xs}px) {
                    font-size: ${rem('11px')};
                }
            }
            .icon-wrapper {
                height: ${rem(14)} !important;
                svg {
                    height: inherit !important;
                    color: ${({ theme }) => theme.colors.grey21};
                    path {
                        fill: ${({ theme }) => theme.colors.grey21};
                    }
                }
            }

            &.need-help-link {
                padding: 0 !important;
            }
        }

        .header__nav-description {
            &_secondary {
                margin-top: -${rem('3px')};
            }
        }

        .logoutBox .accountStatement:hover p {
            color: ${({ theme }) => theme.colors.primary};
        }

        .logoutBox .accountStatement:hover {
            p {
                color: ${({ theme }) => theme.colors.primary};
            }
        }

        .icon-wrapper svg {
            width: ${rem('30px')};
        }

        .logoutBox {
            path {
                fill: ${({ theme }) => theme.colors.grey8};
            }

            a {
                padding: 0.5rem 1rem !important;
                display: block !important;
                margin: 0 0.5rem !important;

                p {
                    margin: 0 !important;
                    text-align: center;
                }

                :hover {
                    background-color: ${({ theme }) => theme.colors.primary} !important;
                    p {
                        color: ${({ theme }) => theme.colors.black2} !important;
                    }
                }

                :not(:first-child) {
                    margin-top: 0.5rem !important;
                }
            }
        }

        .need-help-open {
            background: #e5e5e5 !important;

            .header__nav-description {
                background: #e5e5e5 !important;
            }
        }

        .need-help-section {
            left: 100%;
            transform: translateX(-100%);

            @media (min-width: ${breakpoints.sm}px) {
                top: 120%;
            }
        }
    }

    svg {
        path {
            fill: ${({ theme }) => theme.colors.black2};
        }
    }

    .link-section {
        a {
            padding-bottom: ${rem('16px')};
            margin-bottom: ${rem('-38px')};
            :hover {
                /* not specified in design */
                color: ${({ theme }) => theme.colors.primaryDisabled};
                border-bottom-color: ${({ theme }) => theme.colors.primaryDisabled};
            }
        }
    }
`;
